import React from 'react'

import { IconProps } from '.'

const Send: React.FC<IconProps> = ({ ...rest }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect width="32" height="32" rx="16" fill="#E55C8A" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8 9.54558C11.6216 8.7961 12.8533 8.50978 14.0143 9.12979L21.7842 13.2794C23.907 14.4131 23.9049 17.6103 21.7802 18.7407L14.0144 22.8723C12.8528 23.4903 11.6218 23.2022 10.8013 22.4517C9.9843 21.7045 9.55433 20.4872 9.93674 19.2156L10.8999 16.013L9.93167 12.7811C9.5505 11.5088 9.98198 10.2918 10.8 9.54558ZM11.8682 16.5549L10.9742 19.5276C10.7183 20.3786 11.0052 21.1701 11.5324 21.6523C12.0561 22.1313 12.7965 22.2932 13.5056 21.9159L21.2714 17.7843C22.6305 17.0612 22.6322 14.9604 21.2739 14.235L13.5039 10.0854C12.7951 9.70684 12.0544 9.86769 11.5301 10.3459C11.0023 10.8275 10.7143 11.6187 10.9694 12.4702L11.8686 15.4716H13.9413C14.2404 15.4716 14.483 15.7141 14.483 16.0132C14.483 16.3124 14.2404 16.5549 13.9413 16.5549H11.8682Z"
        fill="#fff"
      />
    </svg>
  )
}

export default Send
